<template lang="pug">
  #create-account
    HeaderForLogin
    h2.font-weight-bold.text-muted.text-center クラウド版サポートサイト アカウント作成お申込み
    b-card.mx-auto.body-width.mt-4(body-class="px-5")
      .form-box.mx-auto.text-center
        div(v-if="error_msg_list.length > 0")
          b-form-text.align-left.text-left.error-message-color.white-space(v-for="(error_msg, error_key) of error_msg_list", :key="error_key") {{error_msg}}
        b-form(@submit.prevent="send")
          b-form-group.mt-4
            b-container
              b-row
                b-col
                  b-form-input.mt-1(v-model="domain_name.value", required, placeholder="サブドメイン名", :state="domain_name.error_messages.length === 0 ? null : false")
                b-col
                  b-form-radio-group.radio-align-left.domain-name-font-size(v-model="domain_select.value", :checked="domain_select.options[0].value", :state="domain_select.error_messages.length === 0 ? null : false")
                    b-form-radio(:value="domain_select.options[0].value") {{domain_select.options[0].name}}
                    b-form-radio(:value="domain_select.options[1].value") {{domain_select.options[1].name}}
            sub-domain-tool-tips.text-left
            b-form-text.align-left.text-left.error-message-color(v-for="(message, key) of domain_name.error_messages", :key="key") {{message}}
            b-form-text.align-left.text-left.error-message-color(v-for="(message, key) of domain_select.error_messages", :key="key") {{message}}
          b-form-group.mt-2
            b-form-input.mt-1(v-model="client_no.value", required, placeholder="お客様番号", :state="client_no.error_messages.length === 0 ? null : false")
            b-form-text.align-left.text-left.error-message-color(v-for="(message, key) of client_no.error_messages", :key="key") {{message}}
            b-form-text.text-left.white-space {{customer_description}}
          b-button.w-100.mt-2.mb-3(type="submit", :disabled="isLoading", variant="primary") 申し込む
          router-link(:to="{name: 'Login'}") ログイン画面に戻る
</template>

<script>
import Api from "@/repositories/api"
import HeaderForLogin from "@/components/supportSite/HeaderForLogin";
import SubDomainToolTips from "@/components/supportSite/SubDomainToolTips";

const S209CreateAccount = Api.get("s209CreateAccount")

export default {
  name: "OrderNewAccount",
  components: {
    HeaderForLogin,
    SubDomainToolTips
  },
  data() {
    return {
      // サブドメイン名
      domain_name: { value: "", error_messages: [] },

      // サブドメイン種別
      domain_select: {
        value: "0",
        options: [
          { value: "0", name: ".dn-cloud.com" },
          { value: "1", name: ".chatluck.net" }
        ],
        error_messages: [],
      },

      // お客様番号
      client_no: { value: "", error_messages: [] },

      customer_description: "※「A」から始まる半角英数字をご入力ください。\n※お客様番号は請求書、または開通メールをご確認ください。",

      // 画面上部に表示するエラーメッセージ
      error_msg_list: [],
    }
  },
  methods: {
    send() {
      // 送信ボタンをロックする
      this.isLoading = true;

      // エラーメッセージ初期化
      this.error_msg_list               = []; // 画面上部に表示するエラーメッセージ
      this.domain_name.error_messages   = []; // サブドメイン名
      this.domain_select.error_messages = []; // サブドメイン種別
      this.client_no.error_messages     = []; // お客様番号

      // リクエストデータ作成
      let requestData = {
        subdomain_name: this.domain_name.value,   // サブドメイン名
        subdomain_type: this.domain_select.value, // サブドメイン種別
        client_no:      this.client_no.value      // お客様番号
      };

      // アカウント作成チェック処理呼び出し
      S209CreateAccount.check(requestData)
      // 登録成功
      .then(() => {
        // アカウント作成登録画面へ遷移する
        this.$router.push({
          name: "CreateNewAccount",
          params: {
            client_no: this.client_no.value
          }
        })
      })
      // 失敗
      .catch((error) => {
        // 送信ボタンをロックを解除する
        this.isLoading = false;

        // 共通のエラー処理
        this.apiError(error, "画面表示処理")

        // バリデーションエラー
        if (error.response.data && error.response.data.error_list) {
          for (let errorData of error.response.data.error_list) {
            switch(errorData.target){
              // サブドメイン名のエラーメッセージの場合
              case 'subdomain_name':
                this.domain_name.error_messages.push(errorData.error_msg)

                break
              // サブドメイン種別のエラーメッセージの場合
              case 'subdomain_type':
                this.domain_select.error_messages.push(errorData.error_msg)

                break
              // お客様番号のエラーメッセージの場合
              case 'client_no':
                this.client_no.error_messages.push(errorData.error_msg)

                break
              // その他(データ無し等)
              default:
                this.error_msg_list.push(errorData.error_msg)
            }
          }
        }
        // その他エラー
        else {
          this.error_msg_list.push(error)
        }
      })
    }
  }
}
</script>

<style scoped>
.body-width {
  max-width: 1200px;
}
.form-box {
  max-width: 540px;
}
.white-space {
  white-space: pre-wrap;
}
</style>